import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;

  .ant-input-search {
    max-width: 250px !important;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  padding: 4px 16px;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    border-color: ${({ theme }) => theme.colors.green7};
    color: ${({ theme }) => theme.colors.green7};
  }
`;

export const PopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;
